<template>
  <div class="bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate" :class="switchClass">
    <div class="bootstrap-switch-container" @click="triggerToggle()">
      <span class="bootstrap-switch-handle-on" :class="colorClass" :style="onSpanStyle">
        <slot name="on">{{onText}}</slot>
      </span>
      <span class="bootstrap-switch-label" id="label" :style="labelStyle"></span>
      <span class="bootstrap-switch-handle-off bootstrap-switch-default" :class="colorClass" style="padding-right:5em;padding-left:0.5em;">
        <slot name="off">{{offText}}</slot>
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: "n-switch",
  props: {
    value: [Array, Boolean],
    onText: String,
    offText: String,
    color: String,
  },
  computed: {
    switchClass() {
      let base = "bootstrap-switch-";
      let state = this.model ? "on" : "off";
      let classes = base + state;
      return classes;
    },
    colorClass() {
      let base = "bootstrap-switch-";
      let colorClass = this.color ? base + this.color : "";
      return colorClass;
    },
    labelStyle() {
      let styleObject = {
        left: this.model ? "60%" : "45%",
      };
      return styleObject;
    },
    onSpanStyle() {
      let styleObject = {
        "padding-right": this.model ? "5em" : "",
      };
      return styleObject;
    },
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    triggerToggle() {
      this.model = !this.model;
    },
  },
};
</script>
<style>
#label {
  background: #fff;
}
</style>
